module.exports = __webpack_public_path__ + "img/invoiceExport.052e2940.png";